/**
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */
var module; UMD(module, {
  'minted:m': ['M'],
})(this, function (m_module) {
  var M = m_module.M;
  if (typeof M === "undefined") {
    M = {}; // Minted namespace
  }

  /**
   * Templito passes each template to this function as it is defined, allowing
   * us to hook into each underscore template to make changes.
   *
   * @param {Function} template The compiled underscore template function
   *
   * @return {Function} A template function that wraps the compiled underscore
   * template function.
   */
  M.templateWrapper = function (template) {
    return function () {
      var result = template.apply(this, arguments);
      // This allows us to pass the template result into jQuery 1.9 for
      // parsing. Leading whitespace will break in jQuery 1.9.
      return result.trim();
    };
  };

  return {};
});
